// Iframe embeds are not restricted to a domain allowlist — instructors can embed a
// wide variety of third-party activities. The only gate is a scheme check that keeps
// the rendered `src` to well-formed http(s) URLs, which blocks `javascript:`/`data:`
// injection. The iframe's `sandbox` attribute (set where it is rendered) remains the
// real isolation boundary.
export const IFRAME_UNAVAILABLE_MESSAGE =
  'This embedded activity is unavailable because its source is missing or invalid.';

export function isRenderableIframeSource(source: string | undefined): boolean {
  const trimmed = source?.trim();

  if (!trimmed) {
    return false;
  }

  try {
    const { protocol } = new URL(trimmed);

    return protocol === 'https:' || protocol === 'http:';
  } catch {
    return false;
  }
}
